"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.Container = exports.Card = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _spacing = _interopRequireDefault(require("../../theming/spacing"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "CardImagestyle__Container",
  componentId: "sc-30ydpi-0"
})(function (_ref) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    breakpoint = _ref$theme.breakpoint;
  return _defineProperty(_defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: "-".concat(spacing.inline['3xs']),
    marginRight: "-".concat(spacing.inline['3xs'])
  }, breakpoint.sm(), {
    marginLeft: "-".concat(spacing.inline['2xs']),
    marginRight: "-".concat(spacing.inline['2xs'])
  }), breakpoint.md(), {
    marginLeft: 0,
    marginRight: 0
  });
});
var Image = exports.Image = _styledComponents["default"].img.withConfig({
  displayName: "CardImagestyle__Image",
  componentId: "sc-30ydpi-1"
})(function (_ref3) {
  var color = _ref3.theme.color;
  return {
    borderTop: "3px solid ".concat(color.brandSecondary.dark),
    objectFit: 'cover',
    objectPosition: 'top',
    width: '100%',
    height: '176px',
    position: 'relative'
  };
});
var Card = exports.Card = _styledComponents["default"].div.withConfig({
  displayName: "CardImagestyle__Card",
  componentId: "sc-30ydpi-2"
})(function (_ref4) {
  var padding = _ref4.padding,
    _ref4$theme = _ref4.theme,
    color = _ref4$theme.color,
    breakpoint = _ref4$theme.breakpoint,
    shadow = _ref4$theme.shadow,
    spacing = _ref4$theme.spacing,
    border = _ref4$theme.border;
  return _defineProperty({
    background: color.neutral['08'],
    borderRadius: border.radius.sm,
    boxShadow: shadow.level['02'],
    boxSizing: 'border-box',
    position: 'relative',
    minHeight: '100%',
    padding: padding ? _spacing["default"].apply(void 0, _toConsumableArray(padding)) : spacing.squeeze.sm,
    maxWidth: '240px',
    marginTop: '-76px',
    marginLeft: spacing.inline['3xs'],
    marginRight: spacing.inline['3xs']
  }, breakpoint.sm(), {
    marginLeft: spacing.inline['2xs'],
    marginRight: spacing.inline['2xs']
  });
});